import { Reveal } from "./Reveal";
import { useLang } from "../i18n";

export const BakhoorSection = () => {
    const { t } = useLang();
    const CHAPTERS = [
        { n: "01", title: t("bakhoor.c1t"), text: t("bakhoor.c1x") },
        { n: "02", title: t("bakhoor.c2t"), text: t("bakhoor.c2x") },
        { n: "03", title: t("bakhoor.c3t"), text: t("bakhoor.c3x") },
    ];
    return (
        <section id="bakhoor-collection" className="bg-charcoal py-28 sm:py-40 px-6 sm:px-10" data-testid="bakhoor-section">
            <div className="max-w-7xl mx-auto">
                <Reveal>
                    <p className="text-xs tracking-[0.35em] uppercase text-gold mb-6">{t("bakhoor.overline")}</p>
                    <h2 className="font-serif text-4xl sm:text-5xl tracking-tight leading-tight text-ivory mb-6" data-testid="bakhoor-heading">
                        {t("bakhoor.heading")}
                    </h2>
                    <p className="text-ivory/50 text-sm sm:text-base max-w-2xl leading-relaxed mb-20">{t("bakhoor.body")}</p>
                </Reveal>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-gold/20 border border-gold/20">
                    {CHAPTERS.map((c, i) => (
                        <Reveal key={c.n} delay={i * 0.15} className="bg-charcoal">
                            <div className="p-10 sm:p-12 h-full group hover:bg-[#221F19] transition-colors duration-500" data-testid={`bakhoor-chapter-${c.n}`}>
                                <span className="font-serif text-4xl text-gold/40 group-hover:text-gold/70 transition-colors duration-500">{c.n}</span>
                                <h3 className="font-serif text-2xl tracking-tight text-ivory mt-10 mb-4">{c.title}</h3>
                                <p className="text-sm text-ivory/50 leading-relaxed">{c.text}</p>
                            </div>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
};
